import React, { useRef, useState } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Html } from "@react-three/drei";

function Mascot() {
  return (
    <mesh>
      <sphereGeometry args={[1, 32, 32]} />
      <meshStandardMaterial color="#FF6B6B" />
    </mesh>
  );
}

function Chat3D() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  const handleSend = async () => {
    if (!input) return;
    const userMsg = { sender: "child", text: input };
    setMessages([...messages, userMsg]);
    setInput("");

    // AI response placeholder (replace with real API call)
    const aiResponse = await getAIResponse(input);

    setMessages((prev) => [...prev, { sender: "talkytoon", text: aiResponse }]);

    // Speak response
    const utter = new SpeechSynthesisUtterance(aiResponse);
    utter.lang = "en-US";
    utter.pitch = 1.2;
    window.speechSynthesis.speak(utter);
  };

  const getAIResponse = async (text) => {
    // Here you can call OpenAI GPT-4 API with kid-safe prompt
    // For now, simple placeholder
    const safeReplies = [
      "😺 Haha! That's funny!",
      "Yay! You did it! 🎉",
      "I love talking to you! 🐱",
      "Wow! Tell me more!",
    ];
    return safeReplies[Math.floor(Math.random() * safeReplies.length)];
  };

  return (
    <div className="flex flex-col items-center p-4">
      <div className="w-full h-64 md:h-96 border rounded-lg mb-4">
        <Canvas>
          <ambientLight />
          <pointLight position={[10, 10, 10]} />
          <Mascot />
          <OrbitControls enableZoom={false} />
          <Html position={[0, -2, 0]}>
            <div className="text-center text-xl font-bold text-purple-600">
              TalkyToon 🐱
            </div>
          </Html>
        </Canvas>
      </div>

      <div className="w-full md:w-1/2 flex flex-col space-y-2">
        <div className="flex flex-col space-y-1 max-h-60 overflow-y-auto border p-2 rounded-lg bg-yellow-50">
          {messages.map((msg, i) => (
            <div
              key={i}
              className={`p-2 rounded-lg ${
                msg.sender === "child" ? "bg-blue-300 self-end" : "bg-pink-300 self-start"
              }`}
            >
              {msg.text}
            </div>
          ))}
        </div>

        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Type your question..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="flex-1 p-2 rounded-lg border"
          />
          <button
            onClick={handleSend}
            className="bg-pink-500 text-white px-4 py-2 rounded-lg hover:bg-pink-600"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}

export default Chat3D;
